import { chef } from 'cookery';
import fieldBaseTpl from '../base';
import './styles';

const fieldRadioGroupTpl = (initData = {}) => {
    return fieldBaseTpl(initData);
}

export { fieldRadioGroupTpl }